import { render, staticRenderFns } from "./lawRankingList.vue?vue&type=template&id=66e78dff&scoped=true&"
import script from "./lawRankingList.vue?vue&type=script&lang=js&"
export * from "./lawRankingList.vue?vue&type=script&lang=js&"
import style0 from "./lawRankingList.vue?vue&type=style&index=0&id=66e78dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e78dff",
  null
  
)

export default component.exports